import useCustomHook from '@/hooks/useCustomHook';
import { useEffect } from 'react';

export default function useStudentSummary({ answers, screens }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      correct: 0,
      failedQuestions: [],
    },
  });

  useEffect(() => {
    let correctCount = 0;
    let totalCount = 0;
    const failedQuestions = [];
    for (const screen of screens) {
      for (const question of screen.questions) {
        totalCount++;
        const answer = answers.find(
          (answer) => answer.questionId == question.id
        );
        if (answer?.correct) {
          correctCount++;
        } else {
          failedQuestions.push(question);
        }
      }
    }
    const correct = parseInt((correctCount * 100) / totalCount);
    actions.setState({ progress: 100, correct, failedQuestions });
  }, [answers, screens]);

  return { state, actions };
}
